var _BlobReadable_blob;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
/**
 * IReadable implementation for Blob (and File, which is a Blob).
 */
export class BlobReadable {
    constructor(blob) {
        _BlobReadable_blob.set(this, void 0);
        __classPrivateFieldSet(this, _BlobReadable_blob, blob, "f");
    }
    async size() {
        return BigInt(__classPrivateFieldGet(this, _BlobReadable_blob, "f").size);
    }
    async read(offset, size) {
        if (offset + size > __classPrivateFieldGet(this, _BlobReadable_blob, "f").size) {
            throw new Error(`Read of ${size} bytes at offset ${offset} exceeds file size ${__classPrivateFieldGet(this, _BlobReadable_blob, "f").size}`);
        }
        return new Uint8Array(await __classPrivateFieldGet(this, _BlobReadable_blob, "f").slice(Number(offset), Number(offset + size)).arrayBuffer());
    }
}
_BlobReadable_blob = new WeakMap();
